import { defineMessages } from 'react-intl'

import { CONTAINERS } from './constants'

export const containersMessages = defineMessages({
  [CONTAINERS.CAN]: {
    id: 'spanish.items.containers.can',
    defaultMessage: 'Lata'
  },
  [CONTAINERS.PET]: {
    id: 'spanish.items.containers.pet',
    defaultMessage: 'Pet'
  },
  [CONTAINERS.BAG]: {
    id: 'spanish.items.containers.bag',
    defaultMessage: 'Bolsita'
  },
  [CONTAINERS.PACKAGE]: {
    id: 'spanish.items.containers.package',
    defaultMessage: 'Paquete'
  }
})
